import { useEffect, useState } from "react";

/**
 * The last place the mouse, a finger or a pen touched, in client pixels
 * (null until the first move). Updates at most once a frame, so a room
 * of creatures re-renders with the screen, not with every event.
 */
export default function usePointer() {
  const [point, setPoint] = useState(null);
  useEffect(() => {
    let frame = 0;
    let next = null;
    const flush = () => {
      frame = 0;
      setPoint(next);
    };
    const onMove = (event) => {
      next = { x: event.clientX, y: event.clientY };
      if (!frame) frame = requestAnimationFrame(flush);
    };
    window.addEventListener("pointermove", onMove, { passive: true });
    window.addEventListener("pointerdown", onMove, { passive: true });
    return () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerdown", onMove);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);
  return point;
}
